export const imanager = function () {
    return window.cf
        .create()
        .graph("Interaction Manager")
        .set("skin", { 
            type: "modern",
            filter: {
                palette: ["#51b364", "#e39802", "#309143", "#f0bd27"]
            },
            emptyItem: { 
                text: "",
            },
            trash: { 
                show: false
            }
        })
}